type ApplicantKey = 'applicant' | 'coapplicant' | 'eitherApplicant';

export interface FieldConf {
  label: string;
  id: string;
}

const SHARED_APPLICANT_FIELDS = [
  { label: 'First Name', id: 'firstName' },
  { label: 'Middle Name', id: 'middleName' },
  { label: 'Last Name', id: 'lastName' },
  { label: 'Phone', id: 'phone' },
  { label: 'Home Phone', id: 'homePhone' },
  { label: 'Email', id: 'email' },
  { label: 'Driver License Number', id: 'driverLicenseNumber' },
  {
    label: 'Driver License State (or Province in Canada)',
    id: 'driverLicenseState',
  },
  { label: 'Birthday', id: 'birthday' },
  { label: 'Social Number', id: 'socialSec' },
  { label: 'Address', id: 'address' },
  { label: 'City', id: 'city' },
  { label: 'State (or Province in Canada)', id: 'state' },
  { label: 'Zip', id: 'zip' },
  { label: 'County', id: 'county' },
  { label: 'Apt', id: 'apt' },
  { label: 'Years at Address', id: 'yearsAtAddress' },
  { label: 'Months at Address', id: 'monthsAtAddress' },
  { label: 'Housing Status', id: 'rentType' },
  { label: 'Housing Mo. Pmt', id: 'mortgageLease' },
  { label: 'Prev. Address', id: 'prevAddress' },
  { label: 'Prev. City', id: 'prevCity' },
  { label: 'Prev. State (or Province in Canada)', id: 'prevState' },
  { label: 'Prev. Zip', id: 'prevZip' },
  { label: 'Prev. Apt', id: 'prevApt' },
  { label: 'Prev. Years at Address', id: 'prevYearsAtAddress' },
  { label: 'Prev. Months at Address', id: 'prevMonthsAtAddress' },
  { label: 'Employment Status', id: 'employmentStatus' },
  { label: 'Job Title', id: 'jobTitle' },
  { label: 'Company Name', id: 'companyName' },
  { label: 'Company Address', id: 'companyAddress' },
  { label: 'Company State (or Province in Canada)', id: 'companyState' },
  { label: 'Company City', id: 'companyCity' },
  { label: 'Company Zip', id: 'companyZip' },
  { label: 'Years at Company', id: 'yearsAtCompany' },
  { label: 'Months at Company', id: 'monthsAtCompany' },
  { label: "Employer's Phone", id: 'employerPhone' },
  { label: 'Monthly Salary', id: 'monthlySalary' },
  { label: 'Other Income', id: 'otherIncome' },
  { label: 'Other Income Source', id: 'otherIncomeSource' },
  { label: 'Prev. Job Title', id: 'prevJobTitle' },
  { label: 'Prev. Company Name', id: 'prevCompanyName' },
  { label: 'Prev. Company Phone', id: 'prevCompanyPhone' },
  { label: 'Years at Prev. Company', id: 'prevYearsAtCompany' },
  { label: 'Months at Prev. Company', id: 'prevMonthsAtCompany' },
  { label: 'Reference #1 First Name', id: 'references[0].firstName' },
  { label: 'Reference #1 Last Name', id: 'references[0].lastName' },
  { label: 'Reference #1 Phone', id: 'references[0].phone' },
  { label: 'Reference #1 Address', id: 'references[0].address' },
  { label: 'Reference #1 City', id: 'references[0].city' },
  {
    label: 'Reference #1 State (or Province in Canada)',
    id: 'references[0].state',
  },
  { label: 'Reference #1 Zip', id: 'references[0].zip' },
  { label: 'Reference #2 First Name', id: 'references[1].firstName' },
  { label: 'Reference #2 Last Name', id: 'references[1].lastName' },
  { label: 'Reference #2 Phone', id: 'references[1].phone' },
  { label: 'Reference #2 Address', id: 'references[1].address' },
  { label: 'Reference #2 City', id: 'references[1].city' },
  {
    label: 'Reference #2 State (or Province in Canada)',
    id: 'references[1].state',
  },
  { label: 'Reference #2 Zip', id: 'references[1].zip' },
  { label: 'Reference #3 First Name', id: 'references[2].firstName' },
  { label: 'Reference #3 Last Name', id: 'references[2].lastName' },
  { label: 'Reference #3 Phone', id: 'references[2].phone' },
  { label: 'Reference #3 Address', id: 'references[2].address' },
  { label: 'Reference #3 City', id: 'references[2].city' },
  {
    label: 'Reference #3 State (or Province in Canada)',
    id: 'references[2].state',
  },
  { label: 'Reference #3 Zip', id: 'references[2].zip' },
];

const COAPPLICANT_ONLY_FIELDS = [
  { label: 'Coapplicant Relation', id: 'coapplicantRelation' },
];

const APPLICANT_ONLY_FIELDS = [{ label: 'Signature', id: 'signature' }];

const NO_APPLICANT_FIELDS = [{ label: 'Ownership Options', id: 'financeType' }];

export function getFieldConfig(
  applicantKey: ApplicantKey,
): [
  FieldConf[], // relevant fields
  FieldConf[], // relevant dependencies
] {
  const coapplicantFields = SHARED_APPLICANT_FIELDS.concat(
    COAPPLICANT_ONLY_FIELDS,
  );
  const applicantFields = SHARED_APPLICANT_FIELDS.concat(APPLICANT_ONLY_FIELDS);
  switch (applicantKey) {
    case 'applicant':
      return [applicantFields, applicantFields];
    case 'coapplicant':
      return [coapplicantFields, coapplicantFields];
    case 'eitherApplicant':
      return [NO_APPLICANT_FIELDS, SHARED_APPLICANT_FIELDS];
    default:
      throw new Error(`no such applicant key: ${applicantKey}`);
  }
}

export function getCreditFormKey(
  applicantKey: ApplicantKey,
  fieldId: string,
): string[] {
  if (applicantKey === 'eitherApplicant') {
    return [fieldId];
  }
  return [applicantKey, fieldId];
}
